import Hotjar from '@hotjar/browser';

export const initializeHotjar = (params: { siteId: number; hotjarVersion: number }) => {
  if (process.env.NODE_ENV !== 'production') return;

  Hotjar.init(params.siteId, params.hotjarVersion);
};

export const identifyHotjar = (
  userId: string | null,
  userInfo: Record<string | number, string | number | Date | boolean>,
) => {
  if (process.env.NODE_ENV !== 'production') return;
  if (!Hotjar.isReady()) return;

  Hotjar.identify(userId, userInfo);
};
